import { render, staticRenderFns } from "./BasicHeader.vue?vue&type=template&id=2353261e&scoped=true&"
import script from "./BasicHeader.vue?vue&type=script&lang=js&"
export * from "./BasicHeader.vue?vue&type=script&lang=js&"
import style0 from "./BasicHeader.vue?vue&type=style&index=0&id=2353261e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2353261e",
  null
  
)

export default component.exports